import React from 'react';
import { PictoProps } from './index';

export const Location = (props: PictoProps) => (
  <svg
    width={props.width || '21'}
    height={props.height || '24'}
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.896 10C19.896 17 10.896 23 10.896 23C10.896 23 1.896 17 1.896 10C1.896 5.02944 5.92543 1 10.896 1C15.8666 1 19.896 5.02944 19.896 10V10Z"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="10.896"
      cy="10"
      r="3"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
